// extracted by mini-css-extract-plugin
export default {"FeedCard":"Feedcard_FeedCard__O1FOS"};